/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Fcanswer1Inputs */

const zh_landing_admin_fcanswer1 = /** @type {(inputs: Landing_Admin_Fcanswer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`线粒体`)
};

const en_landing_admin_fcanswer1 = /** @type {(inputs: Landing_Admin_Fcanswer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitochondria`)
};

const es_landing_admin_fcanswer1 = /** @type {(inputs: Landing_Admin_Fcanswer1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La mitocondria`)
};

/**
* | output |
* | --- |
* | "Mitochondria" |
*
* @param {Landing_Admin_Fcanswer1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_fcanswer1 = /** @type {((inputs?: Landing_Admin_Fcanswer1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Fcanswer1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_fcanswer1(inputs)
	if (locale === "en") return en_landing_admin_fcanswer1(inputs)
	return es_landing_admin_fcanswer1(inputs)
});
export { landing_admin_fcanswer1 as "landing_admin_fcAnswer" }